import { TextFieldHelper } from "@goodgamestudios/core";
import { Balancing } from "../../../constants/shared/Balancing";
import { Poker2Model } from "../../../model/Poker2Model";
import { PokerTextHelper } from "../../helper/PokerTextHelper";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2MailVerificationGiftDialogProperties } from "./Poker2MailVerificationGiftDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2MailVerificationGiftDialog extends Poker2Dialog {
    public static NAME: string = "Poker2MailVerificationGiftDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }

    protected applyProperties(): void {
        this.mailDialog.btn_ok.label = Poker2Model.languageData.getTextById("generic_btn_okay");
        TextFieldHelper.changeTextFromatSizeByTextWidth(24, this.mailDialog.txt_title, this.mailDialogProperties.title);
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.mailDialog.txt_copy, this.mailDialogProperties.copy, 2);
        this.mailDialog.txt_chips.text = PokerTextHelper.getShortGroupNumberString(5000);
        //	mailDialog.mc_giftIcon.gotoAndStop( mailDialogProperties.dialogType == "getGift" ? 1 : 2 );
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        if (event.target == this.mailDialog.btn_close || event.target == this.mailDialog.btn_ok)
            this.hide();
    }

    protected get mailDialogProperties(): Poker2MailVerificationGiftDialogProperties {
        return this.properties as Poker2MailVerificationGiftDialogProperties;
    }

    protected get mailDialog(): Library.PokerPopUps.Poker2MailVerificationGift {
        return this.disp as Library.PokerPopUps.Poker2MailVerificationGift;
    }
}
